<template>
  <div>
    <table
      class="darwin-table"
      :class="{ 'darwin-table--hover': hover }"
    >
      <thead v-if="!noHeaders">
        <tr>
          <th
            v-for="col in columns"
            :key="col.key"
          >
            {{ col.label }}
            <SortButton
              v-if="col.sortBy"
              kind="transparent"
              flair="soft"
              size="xs"
              :direction="col.sortBy"
              @change="emit('sort', col.key, $event)"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in data"
          :key="row.id"
        >
          <td
            v-for="column in columns"
            :key="column.key"
            :class="column.class"
          >
            <slot
              :name="column.key"
              :row-index="rowIndex"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
export default {
  name: 'DarwinTable',
}
</script>

<script lang="ts" setup>
import SortButton from '@/uiKit/Icons/SortButton.vue'
import type { SortDirectionType } from '@/uiKit/types'

type ColumnItemDescriptor = {
  key: string
  label?: string
  class?: string
  sortBy?: SortDirectionType | 'none'
}

defineProps<{
  columns: ColumnItemDescriptor[]
  data: { id: string }[]
  noHeaders?: boolean
  hover?: boolean
}>()

const emit = defineEmits<{
  (e: 'sort', col: string, direction: SortDirectionType | 'none'): void
}>()
</script>

<style lang="scss" scoped>
table.darwin-table {
  width: 100%;
  border-collapse: collapse;

  thead {
    text-align: left;
    font-weight: bold;

    th {
      @include typographyRegularBody200;
      color: var(--color-text-default);
      padding: 15px 5px;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid var(--color-border-default);
    }

    tr:last-child {
      border-bottom: none;
    }

    td {
      @include typographyRegularBody200;
      color: var(--color-text-subtle);
      padding: 8px 4px;
      vertical-align: middle;
    }
  }

  &--hover {
    tbody {
      tr:hover {
        background: var(--color-surface-secondary);
      }
    }
  }
}
</style>
